export enum CardTypeId {
    Grammar = 17933,
    Vocabulary = 17937,
    Explanation = 17935,
}
